module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dashboard-nav', {
    attrs: {
      "name": "top-creators"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content px-5"
  }, [_vm._m(0), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "table-margin"
  }, [_c('table', {
    staticClass: "text-xs-left"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "my-2"
  }), _vm._v(" "), _vm._l((_vm.top_creators), function(creator, index) {
    return _c('tr', {
      key: index,
      staticClass: "tbl-row"
    }, [_c('td', [_c('div', {
      staticClass: "dflex align-center my-2"
    }, [_c('div', {
      staticClass: "tbl-num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "tbl-img mx-3",
      style: ({
        'background-image': ("url(" + (creator.avatar_url) + ")"),
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "tbl-content"
    }, [_c('div', {
      staticClass: "tbl-title"
    }, [_vm._v(_vm._s(creator.display_name))]), _vm._v(" "), _c('div', {
      staticClass: "tbl-subtitle"
    }, [_vm._v("@" + _vm._s(creator.user) + "  •  " + _vm._s(creator.user_type))])])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "number-text ml-4"
    }, [_vm._v(_vm._s(creator.playedViewed))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "number-text ml-3"
    }, [_vm._v("$" + _vm._s(creator.subscriptionShare))])]), _vm._v(" "), _c('td')])
  })], 2)]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dflex align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/heart-icon.png"),
      "width": "20",
      "height": "20"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "main-heading ml-2"
  }, [_vm._v("These creators will share your subscription this month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "border-bottom"
  }, [_c('th', {
    staticClass: "w-30"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Total plays")]), _vm._v(" "), _c('th', [_vm._v("Earning")]), _vm._v(" "), _c('th', {
    staticClass: "w-30"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ee88bb8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/topCreators/index.vue
// module id = 1824
// module chunks = 180